import types from './types.js';

const registerStep = (number) => ({
    type: types.REGISTER_STEP,
    number,
});

const changeStep = (newStep) => ({
    type: types.CHANGE_STEP,
    step: newStep,
});

const changeExemption = (exemption) => ({
    type: types.CHANGE_EXEMPTION,
    exemption
});

export default {
    registerStep,
    changeStep,
    changeExemption,
};
